import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { ChartModule } from 'primeng/chart';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';

import { MessageService } from 'primeng/api';

import { AuthModule, AuthHttpInterceptor  } from '@auth0/auth0-angular';

import { SnpListComponent } from './snp-list/snp-list.component';
import { SnpDetailComponent } from './snp-detail/snp-detail.component';
import { ConcordanceGraphComponent } from './concordance-graph/concordance-graph.component';
import { DataService } from './services/data.service';
import { ProbeGraphComponent } from './probe-graph/probe-graph.component';
import { ConfigComponent } from './config/config.component';

import { environment } from 'src/environments/environment';
import { ErrorComponent } from './error/error.component';
import { GlobalHttpInterceptor } from './interceptors/global-http.interceptor';
import { OutbredAnalysisComponent } from './outbred-analysis/outbred-analysis.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SnpListComponent,
    SnpDetailComponent,
    ConcordanceGraphComponent,
    ProbeGraphComponent,
    ConfigComponent,
    ErrorComponent,
    OutbredAnalysisComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ButtonModule,
    ChartModule,
    MenubarModule,
    MenuModule,
    InputTextModule,
    TableModule,
    CardModule,
    DropdownModule,
    FormsModule,
    FileUploadModule,
    MessagesModule,
    MessageModule,
    ToggleButtonModule,
    ProgressSpinnerModule,
    CheckboxModule,
    CalendarModule,
    ToastModule,
    InputNumberModule,
    RadioButtonModule,
    MultiSelectModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        // Request this audience at user authentication time
        audience: environment.auth0.audience,
    
        // Request this scope at user authentication time
        scope: environment.auth0.scope,
        redirect_uri: window.location.origin
      },
      httpInterceptor: {
        allowedList: [
          {
            // Match any request that starts 'https://transnetyx-poc.us.auth0.com/api/v2/' (note the asterisk)
            uri: environment.apiUrl + '*',
            tokenOptions: {
            }
          }
        ]
      }
    })
  ],
  providers: [
    DataService, 
    MessageService,
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: AuthHttpInterceptor, 
      multi: true 
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: GlobalHttpInterceptor,
        multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
